import * as React from "react";
import { useParams } from "react-router-dom";
import { 
  useViewChildOffers, 
  ViewUser, 
  MyAppSettingController, 
  ToggleInterestController,
  useFindIsInterested 
} from "@njoy/controller";
import { TemplateSub } from "../../../../components/layouts/TemplateSub";
import { OfferCountdownCard } from "../../../../components/cards/OfferCountdownCard";
import notifyBellIcon from "../../../../assets/svg/notifyBell.svg"
import infoIcon from "../../../../assets/svg/infoIcon.svg";
import NoticeBox from "../../../../components/noticeBox/NoticeBox";
import InvolveMeModal from "../../../../components/modals/involveMeModal"
import locationIcon from "../../../../assets/discovery/location-icon.png";
import Button from "../../../../components/uiMerge/newButton";
import OfferCardSkeleton from "../../../../components/cards/OfferCardSkeleton";
import PageLoader from "src/modules/shared/PageLoader";
import MerchantInfoModal from "src/components/modals/merchantInfoModal";
import ToastMessage from "../../../../hooks/useToast";
import checkIcon from "../../../../assets/svg/check.svg"


export const MerchantChildOffers: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();
  const [visible, setVisible] = React.useState(false);
  const [cancelNotifyModalVisible, setCancelNotifyModalVisible] = React.useState(false);
  const merchantUserId = userId ?? "";

  const { childOffers = [], loading, hasMoreChildOffers, loadMore } = useViewChildOffers({
    userId: userId ?? "",
    limit: 10,
    offset: 0
  });

  const { loading:loadingIsInterested, status, refetch } = useFindIsInterested({
    merchantUserId
  });

  const showModal = () => setVisible(true);
  const handleCancel = () => setVisible(false);
  return (
    <ViewUser userId={userId ?? ""}>
      {(data) => {
        if (!data.user) {
          return <PageLoader />;
        }

        // Handle Admin (merchant) type
        if (data.user.__typename === "AdminPWA") {
          return (
            <>
              <MerchantInfoModal
                visible={visible}
                onCancel={handleCancel}
                merchantCaption={data.user.merchantProfile?.description || ""}
                merchantIcon={data.user.merchantProfile?.logoUrl || ""}
                merchantAddress={data.user.merchantProfile?.companyLocation || ""}
              />

              <TemplateSub
                page={`Merchant Offers`}
                bgImg={data.user.merchantProfile?.bannerUrl || ""}
              >
                <div className="w-full flex-1 h-full pb-4">
                  {/* Merchant Header */}
                  <div className="px-[1rem]">
                    <div className="flex flex-col sticky -mt-[30px] gap-3 z-[101]">
                      <div className="rounded-full">
                        <img
                          src={data.user.merchantProfile?.logoUrl ?? ""}
                          className="object-cover w-[71px] h-[71px] rounded-full"
                          alt=""
                        />
                      </div>
                      <div className="flex w-full flex-col gap-4">
                        <div className="flex flex-col gap-1 w-full">
                          <div className="flex items-center justify-between w-full">
                            <p className="text-[20px] truncate text-white font-semibold">
                              {data.user.merchantProfile?.companyName ?? ""}
                            </p>
                            <div onClick={showModal} className="cursor-pointer">
                              <img src={infoIcon} alt="info" />
                            </div>
                          </div>
                          <p className="text-sm text-[#777]">
                            @{data.user.merchantProfile?.username ?? ""}
                          </p>
                          <div className="flex mb-4 mt-0 items-center">
                            <img src={locationIcon} alt="location" width={16} height={16} />
                            <div className="flex w-full justify-between items-center">
                              <p className="text-[12px] text-[#777] w-[50%] truncate">
                                {data.user.merchantProfile?.companyLocation ?? ""}
                              </p>

                              {
                                (!loadingIsInterested && status === false) && (
                                  <ToggleInterestController>
                                    {({submit, loading}) => (
                                      <div className="flex">
                                        <button
                                          onClick={async() => {
                                              if(data.user && data.user.__typename === "AdminPWA") {
                                                const response = await submit({merchantUserId});
                                                if(response.errors) {
                                                  ToastMessage("error", response.errors.message);
                                                }
                                                ToastMessage("success", response.message || "Interest marked");
                                                refetch()
                                              }
                                            }}
                                          className={`rounded-[5px] flex gap-1 p-2 justify-around items-center text-[10px] w-[83px] h-[20px] text-white border-[1px] border-solid border-white`}>
                                         <img src={notifyBellIcon} alt="notify bell"/> {loading ? "Loading..." : "Involve Me"}
                                        </button>
                                      </div>
                                    )}
                                  </ToggleInterestController>
                                ) 
                              }

                              {
                                (!loadingIsInterested && status === true) && (
                                  <ToggleInterestController>
                                      {({submit, loading}) => (
                                        <>
                                        <button 
                                          style={{ background: 'var(--New-Njoy-Gradient, linear-gradient(270deg, #A151F9 0%, #0045E9 98.3%)' }}
                                          onClick={() => setCancelNotifyModalVisible(true)}
                                          className="flex gap-1 p-2 justify-around items-center rounded-[5px] text-[10px] w-[89px] h-[20px] text-white">
                                          <img src={checkIcon} alt="check icon" /> {loading ? "Loading..." : "I'm Involved"}
                                        </button> 
                                        <InvolveMeModal  visible={cancelNotifyModalVisible} involveMe={async() => { 
                                            if(data.user && data.user.__typename === "AdminPWA") {
                                              const response = await submit({merchantUserId});
                                              if(response.errors) {
                                                ToastMessage("error", response.errors.message);
                                              }
                                              ToastMessage("success", response.message || "Interest marked");
                                              refetch()
                                            }
                                          }} onCancel={() => setCancelNotifyModalVisible(false)}   />
                                          </>
                                      )}
                                  </ToggleInterestController>
                                )
                              }
                            </div>
                          </div>
                          <div>
                            <p className="text-white text-[16px]">Available Offers in {" "}
                              <MyAppSettingController>
                                {({ data, loading }) => (
                                  <span>{loading ? "...loading" : data?.myAppSetting?.location?.city}</span>
                                )}
                              </MyAppSettingController>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="overflow-y-auto h-full">
                    {loading ? (
                      <div className="flex gap-[24px]">
                        <div className="max-w-[222px]"><OfferCardSkeleton /></div>
                        <div className="max-w-[222px]"><OfferCardSkeleton /></div>
                      </div>
                    ) : !childOffers.length && (
                      <div className="grid mt-[15px] mb-[30px] px-[1rem] gap-4">
                        <NoticeBox message="No offer available at the moment" noLeftMargin />
                      </div>
                    )}
                    <div className="grid mt-[15px] mb-[30px] px-[1rem] grid-cols-2 gap-4">
                      {childOffers.map((c) => (
                        <OfferCountdownCard offer={c} key={c.id} />
                      ))}
                    </div>

                    {hasMoreChildOffers && (
                      <div className="flex justify-center mt-5">
                        <Button
                          className="bg-blue-600 mb-10 text-white !text-[14px] px-3 py-1 rounded"
                          onClick={loadMore}
                          loading={loading}
                        >
                          Load More
                        </Button>
                      </div>
                    )}
                  </div>

                </div>
              </TemplateSub>
            </>
          );
        }

        // Handle User type (not a merchant)
        if (data.user.__typename === "CustomerPWA") {
          return (
            <TemplateSub page="User Offers">
              <div className="w-full flex-1 h-full pb-4 flex items-center justify-center">
                <NoticeBox message="This user is not a merchant." noLeftMargin />
              </div>
            </TemplateSub>
          );
        }

        // Optionally handle other types (e.g., Customer, ErrorType)
        return (
          <TemplateSub page="User Offers">
            <div className="w-full flex-1 h-full pb-4 flex items-center justify-center">
              <NoticeBox message="User type not supported for merchant offers." noLeftMargin />
            </div>
          </TemplateSub>
        );
      }}
    </ViewUser>
  );
};